<template>
  <div>
    <!-- Toggle Drawer Button -->
    <v-btn @click="toggleDrawer" rounded dark small color="primary">
      ดูรายละเอียด
    </v-btn>

    <!-- Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      :width="width"
      transition="slide-x-transition"
      class="custom-drawer"
      scrim-opacity="0"
    >
      <div class="drawer-content pt-3" :style="drawerStyle">
        <div class="drawer-header">
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <h4 class="mx-2 mb-0">ตรวจสอบคิวจองรายวัน</h4>
        </div>
        <div>
          <div class="mb-2">{{ flowName }}</div>
          <div class="mb-1" v-if="$session.getAll().data.shopId == shopNameData.velaEntertainment ">
            <v-icon>mdi-account-outline</v-icon>&nbsp;&nbsp;Studio&nbsp;{{
              bookingEmpFlowNameVela
            }}
          </div>
          <div class="mb-1" v-else>
            <v-icon>mdi-account-outline</v-icon>&nbsp;&nbsp;พนักงาน&nbsp;{{
              bookingEmpFlowName
            }}
          </div>
          <div class="mb-1">
            <v-icon>mdi-map-marker-outline</v-icon>&nbsp;&nbsp;สาขา&nbsp;{{
              masBranchName
            }}
          </div>
          <div class="mb-1">
            <v-icon>mdi-calendar-outline</v-icon>&nbsp;&nbsp;{{ formatDate() }}
          </div>
          <div><v-icon>mdi-clock-outline</v-icon>&nbsp;&nbsp;{{ time }}</div>
          <hr />
        </div>
        <div
          v-for="(field, index) in dataCustomField"
          :key="index"
          class="field-container"
        >
          <span class="field-name">{{ field.fieldName }}</span>
          <span class="field-value">{{ field.fieldValue }}</span>
        </div>
        <div
          v-if="
            bookingData &&
              bookingData[0] &&
              (bookingData[0].joyRideInsurance === 'True' ||
                bookingData[0].joyRideReserveNow === 'True' ||
                bookingData[0].menuItem !== null)
          "
          class="ms-2 pa-2"
          style="font-weight: bold;"
        >
          <hr />
          <span v-if="bookingData[0].joyRideInsurance === 'True'">
            จองด่วน 12 ชั่วโมง + 300 บาท </span
          ><br />
          <span v-if="bookingData[0].joyRideReserveNow === 'True'">
            ซื้อประกันอุบัติเหตุเพิ่ม TQM 35 บาท</span
          ><br />
          <!-- <div class="booking-info">
            <span class="price">{{ bookingName[0].price }} บาท</span>
            <span class="name">{{ bookingName[0].name }}</span>
          </div> -->
        </div>

        <div class="field-container">
          <span class="field-name">หมายเหตุ</span>
          <!-- <span class="field-value">{{ dataItem }}</span> -->
        </div>
        <div class="field-container">
          <v-textarea color="black" v-model="dataItem" readonly>
           </v-textarea
          >
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: [
    'bookNo',
    'flowName',
    'masBranchName',
    'date',
    'time',
    'bookingEmpFlowName',
    'bookingEmpFlowNameVela',
    'dataItem'
  ],
  data () {
    return {
      drawer: false,
      dataCustomField: [], // สำหรับเก็บข้อมูลใน Drawer
      bookingData: [],
      bookingName: []
    }
  },
  computed: {
    width () {
      const widths = { xs: '100%', sm: '80%', md: '40%', lg: '40%', xl: '40%' }
      return widths[this.$vuetify.breakpoint.name]
    },
    drawerStyle () {
      return {
        backgroundColor: 'white',
        minHeight: '100vh',
        height: 'auto'
      }
    }
  },
  mounted () {
    if (this.bookNo) {
      console.log('BookNo มีค่า:', this.bookNo)
      console.log('items >>>', this.dataItem)
      console.log('items >>>', this.masBranchName)
      this.getData()
    } else {
      console.log('BookNo ไม่มีค่า')
    }
    this.getBooking()
  },
  methods: {
    toggleDrawer () {
      this.drawer = !this.drawer
    },
    removeScrimBackground () {
      this.$nextTick(() => {
        const scrim = document.querySelector('.v-overlay__scrim')
        if (scrim) {
          scrim.style.backgroundColor = 'transparent'
          scrim.style.opacity = '0'
        }
      })
    },
    closeDialog () {
      this.drawer = false // เปลี่ยนสถานะเพื่อปิด Navigation Drawer
    },
    async getData () {
      console.log('bookNo ', this.bookNo)
      let url = `${this.$DNS_IP}/BookingData/getView?bookNo=${this.bookNo}`

      try {
        const response = await axios.get(url)
        console.log('data all ', response.data)

        for (let index = 0; index < response.data.length; index++) {
          if (response.data[index].fieldType === 'Checkbox') {
            console.log('data index ', typeof response.data[index].fieldValue)

            // Check if fieldValue is falsy (null, undefined, empty string, etc.)
            if (
              response.data[index].fieldValue &&
              response.data[index].fieldValue !== ''
            ) {
              // Convert the fieldValue to an actual array if it's a string
              if (typeof response.data[index].fieldValue === 'string') {
                try {
                  // eslint-disable-next-line no-useless-escape
                  let parsedValue = JSON.parse(
                    response.data[index].fieldValue.replaceAll("'", "'")
                  )

                  // Remove the surrounding [] by assigning the parsed array directly
                  response.data[index].fieldValue = parsedValue.join(', ') // Joins the array elements as a string
                } catch (e) {
                  console.error('Error parsing fieldValue:', e)
                }
              }
            } else {
              // If there's no data in fieldValue (either falsy or empty), set it to '-'
              response.data[index].fieldValue = '-'
            }

            console.log(
              'Converted fieldValue: ',
              response.data[index].fieldValue
            )
          }
        }

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.dataCustomField = response.data
          console.log('Data fetched successfully:', this.dataCustomField)
        } else {
          console.log('No data found or response is not an array.')
          this.dataCustomField = []
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.dataCustomField = []
      }
    },
    async getBooking () {
      console.log('bookNo ', this.bookNo)
      let url = `${this.$DNS_IP}/Booking/get?bookNo=${this.bookNo}`

      try {
        const response = await axios.get(url)

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.bookingData = response.data
          console.log('Data fetched successfully:', this.bookingData)
          this.bookingName = JSON.parse(response.data[0].menuItem)
          console.log('this.bookingName ', typeof this.bookingName)
        } else {
          console.log('No data found or response is not an array.')
          this.bookingData = []
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.bookingData = []
      }
    },
    formatDate () {
      const date = new Date(this.date)
      if (isNaN(date)) {
        return 'Invalid date'
      }
      return new Intl.DateTimeFormat('th-TH', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date)
    }
  },
  watch: {
    bookNo (newVal) {
      if (newVal) {
        console.log('BookNo มีค่า:', newVal)
        this.getData() // เรียกใช้ getData ถ้ามีค่า
      } else {
        console.log('BookNo ไม่มีค่า')
      }
    },
    drawer (value) {
      if (value) {
        this.removeScrimBackground()
      }
    }
  }
}
</script>

<style scoped>
.custom-drawer {
  background-color: white;
}

.drawer-content {
  padding: 16px;
}

.field-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 10px;
}

.field-name {
  flex: 1;
  text-align: left;
  font-weight: normal;
  color: #444;
  margin-right: 10px;
}

.field-value {
  flex: 1;
  text-align: left;
  color: black;
  font-weight: bold;
  padding-left: 20px;
}

.drawer-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.drawer-header h4 {
  margin: 0;
  color: black;
}

.drawer-header v-btn {
  background-color: transparent;
  color: #1976d2;
  transition: background-color 0.3s;
}

.drawer-header v-btn:hover {
  background-color: rgba(25, 118, 210, 0.1);
}
.v-overlay__scrim {
  background-color: transparent !important;
  opacity: 0 !important;
}
.booking-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-direction: row-reverse; /* สลับตำแหน่งซ้าย-ขวา */
}

.price {
  text-align: left; /* ชิดซ้าย */
}

.name {
  text-align: right; /* ชิดขวา */
}
</style>



// WEBPACK FOOTER //
// src/components/DialogModels/DialogCheckQueue.vue